import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'antd';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';

import * as actions from '../store/actions';

import '../styles.less';
import { isArray } from 'lodash';

const type = 'DraggableBodyRow';

const DraggableBodyRow = ({ index, moveRow, className, style, ...restProps }) => {
  const ref = useRef();

  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    },
  });

  const [, drag] = useDrag({
    type,
    item: { index, type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drop(drag(ref));

  return <tr ref={ref} className={`${className}${isOver ? dropClassName : ''}`} style={{ cursor: 'move', ...style }} {...restProps} />;
};

const columns = [
  {
    title: 'Policy Orderer',
    dataIndex: 'value',
    key: 'value',
  },
];

const PoliciesOrderPanelComponent = ({ policiesIds, policiesOrderer, setPoliciesOrderer, disabled }) => {
  const dispatch = useDispatch();

  const policiesByIds = useSelector((state) => state.formEditor.policiesByIds);
  const policiesByIdsLoading = useSelector((state) => state.formEditor.policiesByIdsLoading);

  useEffect(() => {
    if (isArray(policiesIds) && policiesIds.length > 0) {
      dispatch(actions.getPoliciesByIds(policiesIds));
    }
  }, [policiesIds]);

  useEffect(() => {
    if (policiesByIds) {
      setPoliciesOrderer(policiesByIds);
    }
  }, [policiesByIds]);

  const components = {
    body: {
      row: DraggableBodyRow,
    },
  };

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = policiesOrderer[dragIndex];
      const value = update(policiesOrderer, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      setPoliciesOrderer(value);
    },
    [policiesOrderer],
  );

  return (
    <DndProvider backend={HTML5Backend}>
      <Table
        className="policies-order-table"
        columns={columns}
        dataSource={policiesOrderer ?? []}
        components={components}
        loading={policiesByIdsLoading}
        pagination={false}
        bordered
        onRow={(record, index) => ({
          index,
          moveRow,
        })}
        disabled={disabled}
      />
    </DndProvider>
  );
};

export default PoliciesOrderPanelComponent;
